import { render, staticRenderFns } from "./addRukuDiglog.vue?vue&type=template&id=31d888af&scoped=true"
import script from "./addRukuDiglog.vue?vue&type=script&lang=js"
export * from "./addRukuDiglog.vue?vue&type=script&lang=js"
import style0 from "./addRukuDiglog.vue?vue&type=style&index=0&id=31d888af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d888af",
  null
  
)

export default component.exports